import React from "react";
import * as _ from "lodash";

interface BcfButtonProps {
    name: string;
    index: number;
    onClick: () => void;
}

export default class BcfButton extends React.Component<BcfButtonProps> {

    state: { isActive: boolean };
    private readonly name: string;

    constructor(props : BcfButtonProps) {
        super(props);

        this.state = { isActive: false };
        this.setActive.bind(this);

        this.name = this.props.name.length > 80
            ? this.props.name.substring(0, 77) + "..."
            : this.props.name;
    }

    render() {
        return <button id="no-outline-button" key={this.props.index}
            className={this.state.isActive ? "btn btn-primary" : "btn btn-secondary" + " flex-fill"}
            onClick={this.props.onClick}>
            {this.name}
        </button>;
    }

    setActive(active: boolean) {
        this.setState({ isActive: active });
    }
}